module.exports = __webpack_public_path__ + "img/garrafao-agua-color.93ba3536.svg";